/* eslint-disable no-param-reassign */

import React from 'react';
import './BbGuesses.css';

class Guesses extends React.Component {
  constructor(props) {
    super(props);
    this.onGuessesChildChange = this.onGuessesChildChange.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.currentAction !== this.props.currentAction) {
      return true;
    }
    if (nextProps.answer !== this.props.answer) {
      return true;
    }
    if (nextProps.question !== this.props.question) {
      return true;
    }
    if (nextProps.playerGuess !== this.props.playerGuess) {
      return true;
    }
    return false;
  }

  onGuessesChildChange(e) {
    e.preventDefault();
    // Set all buttons to disabled
    const btns = document.querySelectorAll('.bbGuessBtns');
    try {
      btns.forEach((b) => {
        if (b.id === e.target.value) {
          b.className = 'playerChoice btn btn-warning btn-lg bg-gradient my-2 fw-bold disabled shadow-sm';
        } else {
          b.className = 'btn btn-dark btn-lg bg-gradient my-2 fw-bold disabled shadow-sm';
          b.setAttribute('disabled', 'disabled');
        }
      });
      // Send the player guess to parent
      this.props.onGuessesChildChange(e.target.value);
    } catch (error) {
      console.log(`ERROR: ${error}`);
    }
  }

  classSwitcher(arg) {
    if (this.props.answer) {
      if (this.props.answer === arg) {
        return 'bbGuessBtns bbBtnClassCorrect btn btn-success btn-lg bg-gradient my-2 fw-bold disabled shadow-sm';
      }
      if (arg === this.props.playerGuess && arg !== this.props.answer) {
        return 'bbGuessBtns bbBtnClassWrong btn btn-danger btn-lg bg-gradient my-2 fw-bold disabled shadow-sm';
      }
      return 'bbGuessBtns btn btn-dark btn-lg bg-gradient my-2 fw-bold disabled shadow-sm';
    }
    return 'bbGuessBtns btn btn-outline-primary btn-lg my-2 fw-bold shadow-sm';
  }

  makeButtons() {
    const question = this.props.question !== undefined ? this.props.question : '';
    const guesses = [];
    question.forEach((element) => {
      guesses.push(element);
    });
    const buttons = guesses.map((g, i) => {
      const guess = `${g}`;
      const guesskey = guess.replace(/[^a-z0-9]/gi, '');
      return (
        <div className="center" key={`center${guesskey}`}>
          <div className="d-grid gap-2" key={`d${guesskey}`}>
            <button
              type="submit"
              className={`${this.classSwitcher(guess)}`}
              id={guess}
              key={guess}
              data-num={i + 1}
              ref={guess}
              name={guess}
              value={guess}
              onClick={this.onGuessesChildChange}
            >
              {guess}
            </button>
          </div>
        </div>
      );
    });
    return buttons;
  }

  render() {
    console.log('*** GUESSES ***');
    const btns = this.makeButtons();
    return (
      <form key="bbGuessesForm" id="bbGuessesForm" className="my-3">
        {btns}
      </form>
    );
  }
}

export default Guesses;
